import { useState } from "react";
import { Link } from "react-router-dom";
import RunnerGame from "./games/RunnerGame";
import SoccerGame from "./games/SoccerGame";
import PuzzleGame from "./games/PuzzleGame";

const GAMES = [
  {
    id: "runner",
    label: "🏃 سباق المترو",
    tag: "🔥 الأكثر لعباً",
    title: "سباق المترو",
    desc: "اركض وتجنب العقبات في هذا السباق المثير! استخدم مفتاح المسافة أو اضغط على الشاشة للقفز والتهرب من العوائق.",
    features: [
      "تحكم بلمسة واحدة على الموبايل",
      "مستويات بتزيد صعوبة",
      "نقاط وإنجازات يومية",
    ],
    ctaLabel: "🎮 العب النسخة الكاملة",
    Game: RunnerGame,
  },
  {
    id: "soccer",
    label: "⚽ ركلة الجزاء",
    tag: "⚽ رياضة",
    title: "ركلة الجزاء",
    desc: "الحارس اتحداك! اختار الزاوية الصح وسجّل الهدف. كل جول بيزيد الصعوبة — شوف قد إيه تقدر تسجّل!",
    features: [
      "تحديات ضد الحارس الذكي",
      "أكتر من 10 دوري ومسابقة",
      "تنافس مع أصحابك",
    ],
    ctaLabel: "⚽ العب النسخة الكاملة",
    Game: SoccerGame,
  },
  {
    id: "puzzle",
    label: "🍬 سحق الحلوى",
    tag: "🧩 بازل",
    title: "سحق الحلوى",
    desc: "طابق الحلوى وسحقها! العبة بتخلصك من التفكير وتركّزك في المتعة. صعوبة بتزيد مع كل مستوى.",
    features: ["مئات المستويات", "مريحة للأعصاب", "مناسبة لكل الأعمار"],
    ctaLabel: "🍬 العب النسخة الكاملة",
    Game: PuzzleGame,
  },
];

export default function GameTrial() {
  const [active, setActive] = useState("runner");
  const current = GAMES.find((g) => g.id === active);

  return (
    <section className="trial-section" id="try-games">
      <p className="slbl">جرب قبل ما تشترك</p>
      <h2 className="stitle">
        العب <em>تجربة مجانية</em> الآن
      </h2>
      <p className="ssub">شوف بنفسك — 3 ألعاب مختارة تجربها مباشرة في الصفحة</p>

      <div className="trial-tabs">
        {GAMES.map((g) => (
          <button
            key={g.id}
            className={`tab-btn${active === g.id ? " active" : ""}`}
            onClick={() => setActive(g.id)}
          >
            {g.label}
          </button>
        ))}
      </div>

      <div className="trial-arena">
        {GAMES.map((g) => (
          <div
            key={g.id}
            className={`game-demo${active === g.id ? " active" : ""}`}
          >
            <div className="demo-layout">
              <g.Game />
              <div className="demo-info">
                <div className="demo-tag">{g.tag}</div>
                <h3 className="demo-title">{g.title}</h3>
                <p className="demo-desc">{g.desc}</p>
                <ul className="demo-features">
                  {g.features.map((f, i) => (
                    <li key={i}>
                      <span className="ck">✓</span> {f}
                    </li>
                  ))}
                </ul>
                <Link to="/subscribe" className="demo-cta">
                  {g.ctaLabel}
                </Link>
              </div>
            </div>
          </div>
        ))}

        <div className="trial-unlock reveal">
          <div className="trial-games-count">🔓 اشترك وافتح 100+ لعبة</div>
          <h3>عجبتك؟ في كتير كمان!</h3>
          <p>
            هذي 3 بس من 100+ لعبة في شليل للألعاب — كلها بانتظارك باشتراك يومي
            بسيط.
          </p>
          <Link
            to="/subscribe"
            className="btn-p"
            style={{ fontSize: "1.05rem", padding: ".9rem 2.5rem" }}
          >
            🎮 اشترك وألعب الكل
          </Link>
        </div>
      </div>
    </section>
  );
}
